import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatChipListbox, MatChipOption, MatChipSelectionChange } from '@angular/material/chips';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';

@Component({
  selector: 'app-devices-layout',
  templateUrl: './devices-layout.component.html',
  imports: [MatChipListbox, MatChipOption, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevicesLayoutComponent {
  private readonly _router = inject(Router);

  protected readonly activeCategory = toSignal(
    this._router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => this._getCategoryFromUrl((e as NavigationEnd).urlAfterRedirects)),
      startWith(this._getCategoryFromUrl(this._router.url))
    ),
    { initialValue: this._getCategoryFromUrl(this._router.url) }
  );

  private _getCategoryFromUrl(url: string): string {
    if (url.includes('/devices/access-points')) return 'access-points';
    return 'robots';
  }

  handleCategoryChange(event: MatChipSelectionChange): void {
    if (event.selected) {
      this._router.navigate(['/devices', event.source.value]);
    }
  }
}
